import { Link } from 'react-router-dom';

function Terms() {
  return (
    <div className="min-h-screen bg-gray-100 py-10 px-4">
      <div className="max-w-2xl mx-auto bg-white rounded-lg shadow-md p-8">
        <div className="mb-6">
          <Link to="/login" className="text-brand-coral hover:text-brand-coral-dark text-sm">
            ← Back to Sign In
          </Link>
        </div>

        <h1 className="text-2xl font-bold text-brand-black mb-1">Terms of Use &amp; Legal Notice</h1>
        <p className="text-sm text-gray-500 mb-8">
          Effective date: June 2026 — Tighlman Group LLC ·{' '}
          <Link to="/privacy" className="text-brand-coral hover:text-brand-coral-dark">
            Privacy Policy
          </Link>
        </p>

        <div className="space-y-6 text-sm text-gray-700 leading-relaxed">

          <section>
            <h2 className="font-semibold text-gray-900 mb-2">1. Ownership &amp; License</h2>
            <p>
              This software application (the "System") is proprietary to <strong>Tighlman Group LLC</strong>
              ("Developer") and is made available to the client ("Client") under a limited, non-transferable,
              non-exclusive license solely for the Client's internal business operations. All intellectual
              property rights in and to the System — including but not limited to source code, design,
              architecture, and documentation — remain the exclusive property of Tighlman Group LLC.
              No rights are granted beyond those expressly stated herein.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-gray-900 mb-2">2. Authorized Use Only</h2>
            <p>
              Access to this System is strictly limited to personnel expressly authorized by the Client.
              Authorized users may use the System solely for legitimate internal business purposes.
              Any unauthorized access, use, reproduction, distribution, or disclosure of any portion of
              this System is strictly prohibited and may constitute a violation of applicable law,
              including the Computer Fraud and Abuse Act (18 U.S.C. § 1030) and applicable state law.
              Tighlman Group LLC reserves the right to pursue all available legal remedies in the event
              of unauthorized access or misuse.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-gray-900 mb-2">3. Confidentiality</h2>
            <p>
              The System and all data processed within it are confidential. Users may not share,
              copy, screenshot, export, or disclose any information contained in or derived from
              the System to any unauthorized third party. This obligation survives termination of
              access to the System.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-gray-900 mb-2">4. Activity Monitoring</h2>
            <p>
              All access to and activity within the System is logged and monitored, including
              sign-in events and data operations. By accessing the System, users expressly
              consent to such monitoring. Logs may be reviewed by the Client and Tighlman Group LLC
              for security, compliance, and operational purposes.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-gray-900 mb-2">5. Disclaimer of Warranties</h2>
            <p>
              THE SYSTEM IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTY OF ANY KIND,
              EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY,
              FITNESS FOR A PARTICULAR PURPOSE, TITLE, OR NON-INFRINGEMENT. TIGHLMAN GROUP LLC
              DOES NOT WARRANT THAT THE SYSTEM WILL BE UNINTERRUPTED, ERROR-FREE, OR FREE OF
              HARMFUL COMPONENTS. USE OF THE SYSTEM IS AT THE USER'S SOLE RISK.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-gray-900 mb-2">6. Limitation of Liability</h2>
            <p>
              TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, TIGHLMAN GROUP LLC SHALL NOT
              BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES,
              INCLUDING BUT NOT LIMITED TO LOSS OF DATA, LOSS OF REVENUE, LOSS OF PROFITS, OR
              BUSINESS INTERRUPTION, ARISING OUT OF OR RELATED TO USE OF OR INABILITY TO USE THE
              SYSTEM, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. TIGHLMAN GROUP LLC'S
              TOTAL CUMULATIVE LIABILITY ARISING OUT OF OR RELATED TO THESE TERMS SHALL NOT EXCEED
              ONE HUNDRED DOLLARS ($100.00).
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-gray-900 mb-2">7. No Data Backup Guarantee</h2>
            <p>
              Tighlman Group LLC makes no guarantee of data availability, retention, or recovery.
              The Client is solely responsible for maintaining independent backups of any critical
              business information.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-gray-900 mb-2">8. Governing Law &amp; Dispute Resolution</h2>
            <p>
              These Terms shall be governed by and construed in accordance with the laws of the
              State of Arizona, without regard to its conflict of law principles. Any dispute
              arising out of or relating to these Terms or the System shall be resolved exclusively
              in the state or federal courts located in Arizona, and users hereby consent to the
              personal jurisdiction of such courts.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-gray-900 mb-2">9. Modifications</h2>
            <p>
              Tighlman Group LLC reserves the right to modify these Terms at any time. Continued
              use of the System following any modification constitutes acceptance of the updated Terms.
            </p>
          </section>

          <section>
            <h2 className="font-semibold text-gray-900 mb-2">10. Contact</h2>
            <p>
              For questions regarding these Terms or data access, contact Tighlman Group LLC at{' '}
              <a href="mailto:contact@tighlmangroup.com" className="underline hover:text-gray-900">
                contact@tighlmangroup.com
              </a>
              . See also our{' '}
              <Link to="/privacy" className="underline hover:text-gray-900">
                Privacy Policy
              </Link>
              .
            </p>
          </section>

        </div>

        <div className="mt-8 pt-6 border-t border-gray-100 flex flex-wrap items-center gap-4">
          <Link
            to="/login"
            className="bg-brand-coral text-white px-4 py-2 rounded-md hover:bg-brand-coral-dark text-sm"
          >
            Back to Sign In
          </Link>
          <Link to="/privacy" className="text-brand-coral hover:text-brand-coral-dark text-sm">
            Privacy Policy
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Terms;
